import AssignmentFormContainer from './containers/AssignmentFormContainer'

export default AssignmentFormContainer
